import { useEffect, useMemo, useState } from "react";
import {
  LinkOccupantDropdown,
  RequsetTypeDropdown,
  SelectUserCheckboxDropdown,
} from "components";
import SC from "./style";
import { apiPost } from "api/callApi";
import { Checkbox, List } from "@mui/material";
import theme from "theme";
import { useSearchParams } from "react-router-dom";

const RequestContent = ({ setData, data }) => {
  const [roles, setRoles] = useState([]);
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get("projectId");
  const type = searchParams.get("type");
  const [userData, setUserData] = useState([]);

  const roleProjectIds = useMemo(() => {
    if (type != 1) {
      return projectId;
    }

    const linkedOccupants = Array.isArray(data?.linktoproject)
      ? data.linktoproject
      : [data?.linktoproject];

    return [...new Set([projectId, ...linkedOccupants].filter(Boolean))];
  }, [data?.linktoproject, projectId, type]);

  useEffect(() => {
    const fetchRoles = async () => {
      try {
        const response = await apiPost(
          `/v1/options/getroles?active=${true}`,
          {
            projectId: roleProjectIds,
            projectType: type,
          },
          false,
        );
        setRoles(response.data);
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };
    fetchRoles();
  }, [projectId, roleProjectIds, type]);

  const handleChange = (property, value, emails) => {
    setData((prevData) => ({
      ...prevData,
      [property]: value,
    }));

    if (property === "requestType") {
      if (value == 1 || value == 2) {
        setData((prevData) => ({
          ...prevData,
          users: [],
          roles: [],

          sendTo: undefined,
        }));
      }
    }

    if (property === "users") {
      setData((prevData) => ({
        ...prevData,

        sendTo: emails,
      }));
    }
  };

  const onSelectionChange = (id) => {
    setData((prevData) => {
      const updatedRoles = prevData.roles?.includes(id)
        ? prevData.roles.filter((roleId) => roleId !== id)
        : [...(prevData.roles || []), id];

      return {
        ...prevData,
        roles: updatedRoles,
      };
    });
  };

  return (
    <div>
      <SC.ContainerStyle>
        <SC.ITalicSpan>
          <SC.Italic>
            Please note that the journal will be automatically closed if no
            request/include in report is selected and no alarm has been created.
          </SC.Italic>
        </SC.ITalicSpan>
      </SC.ContainerStyle>
      <SC.LabelContainer>
        {type == 0 ? (
          <SC.Label>Select Occupant</SC.Label>
        ) : (
          <SC.Label>Link Other Occupant</SC.Label>
        )}

        <SC.Children>
          <SC.Wrapper>
            <LinkOccupantDropdown
              defaultValue={data?.linktoproject}
              name="linktoproject"
              onChange={handleChange}
              projectId={projectId}
              type={type}
            />
          </SC.Wrapper>
        </SC.Children>
      </SC.LabelContainer>
      {/* Request Type */}
      <SC.LabelContainer>
        <SC.Label>
          Request Type<SC.Astrik>*</SC.Astrik>
        </SC.Label>
        <SC.Children>
          <SC.Wrapper>
            <RequsetTypeDropdown
              defaultValue={data?.requestType}
              name="requestType"
              onChange={handleChange}
            />
          </SC.Wrapper>
        </SC.Children>
      </SC.LabelContainer>

      {data?.requestType === 3 && (
        <>
          <SC.LabelContainer>
            <SC.Label>
              Select Role/s<SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              {roles.length > 0 ? (
                <SC.Wrapper>
                  <List
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    {roles.map((role) => (
                      <label
                        key={role.roleId}
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Checkbox
                          checked={data?.roles?.includes(role.roleId) || false}
                          onChange={() => onSelectionChange(role.roleId)}
                          sx={{
                            "&.Mui-checked": {
                              color: theme.colors.themeColor,
                            },
                          }}
                          size="small"
                        />
                        <span
                          style={{ fontSize: "12px", whiteSpace: "nowrap" }}
                        >
                          {role.role}
                        </span>
                      </label>
                    ))}
                  </List>
                </SC.Wrapper>
              ) : (
                <p style={{ fontSize: "12px", color: "red" }}>
                  No roles available.
                </p>
              )}
            </SC.Children>
          </SC.LabelContainer>

          <SC.LabelContainer>
            <SC.Label>
              Select User <SC.Astrik>*</SC.Astrik>
            </SC.Label>
            <SC.Children>
              <SC.Wrapper>
                <SelectUserCheckboxDropdown
                  onChange={handleChange}
                  defaultValue={data?.users}
                  placeholder="Select user"
                  projectId={projectId}
                  linkedProjectIds={roleProjectIds}
                  type={type}
                  selectRole={data.roles}
                  name="users"
                  setUserData={setUserData}
                />
              </SC.Wrapper>
            </SC.Children>
          </SC.LabelContainer>
        </>
      )}
    </div>
  );
};

export default RequestContent;
